import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({
  activeOcrModerationService: state.settings.activeOcrModerationService,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageOcrSettings
 * @description
 * # manageWhiteList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageOcrSettings', ($ngRedux, $rootScope, $scope, $location, $route, $timeout, $http, ENV) => {
    if (!$scope.isSuperUser) {
      $location.path('/');
    }
    $scope.ocrModerationSettingsProcessing = false;
    $scope.processParams = () =>
      new Promise((resolve) => {
        $scope.getOcrModerationService($http, ENV);
        $scope.currentOcrModerationService = angular.copy($scope.activeOcrModerationService);
        resolve(true);
      });

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.whitelist;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.$watch('activeOcrModerationService', () => {
      if ($scope.activeOcrModerationService) {
        $scope.currentOcrModerationService = angular.copy($scope.activeOcrModerationService);
      }
    });

    $scope.applyError = (error) => {
        const errorData = error.data['ocr-moderation-setting'];
        const details = [];

        Object.keys(errorData).map((key) => {
          if (typeof errorData[key] === 'string') {
            $scope.error.highlightedFields[key] = [errorData[key]];
          } else if (Array.isArray(errorData[key])) {
            $scope.error.highlightedFields[key] = errorData[key];
          } else {
            $scope.error.highlightedFields[key] = Object.values(errorData[key]);
          }
        });

        if (error.status === 500) {
          details.push([
            'There was an error with your request. Please try again in a few minutes.',
          ]);
        } else if (error.status === 400) {
          if (Object.keys($scope.error.highlightedFields).length > 0) {
            details.push('Please fix the highlighted field(s).');
          }
        } else {
          details.push(error.statusText);
        }
        $scope.error.details = details;
      };
      

    $scope.submitOcrModerationService = () => {
      const payload = {
        'ocr-moderation-setting': $scope.currentOcrModerationService,
      };
      $scope.ocrModerationSettingsProcessing = true;
      $scope.error = {
        highlightedFields: {},
        details: [],
      };
      $scope
        .updateOcrModerationService($http, ENV, payload)
        .then(() => {
          $timeout(() => {
            $scope.ocrModerationSettingsProcessing = false;
            $scope.processParams();
          });
        })
        .catch((error) => {
          $timeout(() => {
            $scope.ocrModerationSettingsProcessing = false;
            $scope.applyError(error);
          });
        });
    };

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
